<template>
	<div>
    <content-data :list="id" editpath="/devices/models/list/" :disable-import="true" :key="id" :search="data_search"></content-data>
    <v-btn class="deep-orange" fab dark small fixed top right style="top: 90px; right: 26px;" @click.stop="open_add"><v-icon>add</v-icon></v-btn>


    <v-toolbar color="grey darken-4" fixed dense right style="top: 87px; left: auto; right: 80px; max-width: 300px;">
      <v-text-field color="deep-orange" prepend-icon="search" v-model="data_search" ref="search_field" autofocus clearable hide-details single-line></v-text-field>
    </v-toolbar>


    <BottomSheet :prependExtraTabs="tabs" defaultTab="model_info"></BottomSheet>


  </div>
</template>

<script>
import ContentData from '../content/Data'
import BottomSheet from '../BottomSheet';
import ModelInfo from './editor/ModelInfo'

export default {
	props: ["id"],
	components: {
		ContentData,
    BottomSheet
	},
  data () {
    return {
      tabs: [
        {title: "Model info", name: "model_info", component: ModelInfo},
      ],
      data_search: ""
    }
  },
  mounted () {
    this.$refs.search_field.focus();
  },
	methods:{
    open_add() {
      this.$router.push("/devices/models/list/" + this.id + "/data/new");
    }
  },
  computed: {
  }
}
</script>